import { useEffect, useState } from "react";
import Api from "../openapi";

export default function useAllergens() {
  const [allergenList, setAllergenList] = useState<string[]>([]);
  useEffect(() => {
    const getAllergens = async () => {
      try {
        const res = await Api.Allergen.getAllergens();
        setAllergenList(res.data);
      } catch (error) {}
    };
    getAllergens();
  }, []);
  return allergenList;
}
